import { SoundChannelType } from "../../game/controller/type/SoundChannelType";
import { FileExtension, FileType } from "./FileType";
/*
 * FilePath.ts
 */
export class FilePath {
    constructor(component, element, versionPrefix) {
        this.component = component;
        this.type = element.nodeName;
        this.id = element.getAttribute("id");
        this.locale = element.getAttribute("locale");
        this.notLocale = element.getAttribute("notLocale");
        this.lazy = element.getAttribute("lazy") == "true";
        this.url = versionPrefix + element.getAttribute("url");
        this.loop = element.getAttribute("loop") == "true";
        this.soundChannel = element.getAttribute("soundChannel");
        const scaleParam = parseFloat(element.getAttribute("scale"));
        this.scale = isNaN(scaleParam) ? null : scaleParam;
        const atlasUrl = element.getAttribute("atlasUrl");
        this.atlasUrl = atlasUrl ? versionPrefix + atlasUrl : null;
        const atlas = element.getAttribute("atlas");
        if (atlas && !this.atlasUrl) {
            this.atlasUrl = versionPrefix + atlas + FileExtension.ATLAS;
        }
    }
    getComponent() {
        return this.component;
    }
    getType() {
        return this.type;
    }
    getUrl() {
        return this.url;
    }
    getId() {
        return this.id;
    }
    hasLocale() {
        return this.locale != null;
    }
    hasNotLocale() {
        return this.notLocale != null;
    }
    getLocale() {
        return this.locale;
    }
    getNotLocale() {
        return this.notLocale;
    }
    getScale() {
        return this.scale;
    }
    isFile() {
        return this.type == FileType.FILE;
    }
    isLazy() {
        return this.lazy;
    }
    isSpriteSheet() {
        return this.type == FileType.SPRITE_SHEET;
    }
    isSound() {
        return this.type == FileType.SOUND;
    }
    isVideo() {
        return this.type == FileType.VIDEO;
    }
    isLang() {
        return this.type == FileType.LANG;
    }
    isSpine() {
        return this.type == FileType.SPINE;
    }
    isImage() {
        return this.type === FileType.IMAGE;
    }
    isAtlas() {
        return this.type === FileType.ATLAS;
    }
    getAtlasUrl() {
        if (this.atlasUrl !== null) {
            return this.atlasUrl;
        }
        return this.stripExtension(this.url) + ".atlas";
    }
    stripExtension(url) {
        if (url.lastIndexOf("/") > url.lastIndexOf(".")) {
            return url;
        }
        else {
            return url.substring(0, url.lastIndexOf("."));
        }
    }
    isFont() {
        return this.type == FileType.FONT;
    }
    isLoop() {
        return this.loop;
    }
    getSoundChannel() {
        if (this.soundChannel === "effects") {
            return SoundChannelType.EFFECTS;
        }
        else if (this.soundChannel === "music") {
            return SoundChannelType.MUSIC;
        }
        else if (this.soundChannel === "ambient") {
            return SoundChannelType.AMBIENT;
        }
        else {
            return null;
        }
    }
}
//# sourceMappingURL=FilePath.js.map